// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_style_tabs__2rpga","chips":"tabs_style_chips__oc5ec","selectors":"tabs_style_selectors__3vO8P","fill":"tabs_style_fill__1ylEB","tab":"tabs_style_tab__1bZ8y"};